import { atom, useAtom } from 'jotai';
import { ISubscriptionRate } from 'types';

const productsAtoms = atom<ISubscriptionRate[]>();

export const useProducts = () => {
  const [products, setProducts] = useAtom(productsAtoms);

  return {
    products,
    setProducts,
  };
};
